import { IS_LOADING, IS_SAVING, LEAVE_ADDED, LEAVE_UPDATED, GET_LEAVES } from "./leaveActionsTypes";

const INITIAL_STATE = {
  isLoading: false,
  isSaving: false,
  leaveTypes: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case IS_SAVING:
      return {
        ...state,
        isSaving: action.payload,
      };
    case GET_LEAVES:
      return {
        ...state,
        leaveTypes: action.payload
      };
    case LEAVE_ADDED:
      return {
        ...state,
        leaveTypes: [...state.leaveTypes, action.payload]
      };
    case LEAVE_UPDATED:
      return {
        ...state,
        leaveTypes: state.leaveTypes.map(leave =>
          leave.id === action.payload.id ? { ...leave, ...action.payload } : leave
        )
      };
    default:
      return state;
  }
};
